const searchTypes = Object.freeze({
  CATEGORY: 'Category',
  STORE: 'Store',
  GLOBAL: 'Global',
})

export { searchTypes }
